<div class="main-container">
	<div class="flex-shrink-0">
		<div class="flex flex-col w-full items-center mb-6">
			<div class="bg-blue-100 rounded-full p-4 mb-4 items-center justify-center">
				<activar-icon name="user_edit" size="24px"></activar-icon>
			</div>
			<h2 class="text-lg font-semibold">Modificación de datos</h2>
			<p class="text-gray-600 text-sm">Modificá los datos del tomador.</p>
		</div>
	</div>
	@if(!isLoading()){
		<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="flex-1 flex flex-col min-h-0">
		<div class="flex flex-col gap-4 ">
			
			@if (isCompany()) {
				<!-- Company Form Fields -->
				<activar-input
					type="text"
					placeholder="Seguros y Más SRL"
					label="Razón Social"
					[isSubmitted]="isSubmitted"
					[formControl]="formUtilities.getControl(form, 'companyName')"
					name="companyName"
					[additionalValidators]="
						formUtilities.getValidators(form, 'companyName')
					" />

				<div class="flex flex-col gap-1">
					<label for="identification">CUIT</label>
					<input
						type="text"
						id="identification"
						formControlName="identification"
						class="input__base"
						placeholder="20-12345678-9"
						mask="00-00000000-0"
						cuitBlurNormalize
					/>
					<app-input-error [control]="formUtilities.getControl(form, 'identification')" [submitted]="isSubmitted" />
				</div>
			} @else {
				<!-- Person Form Fields -->
				<activar-input
					type="text"
					placeholder="Juan"
					label="Nombre"
					[isSubmitted]="isSubmitted"
					[formControl]="formUtilities.getControl(form, 'firstName')"
					name="firstName"
					[additionalValidators]="
						formUtilities.getValidators(form, 'firstName')
					" />
				
				<activar-input
					type="text"
					placeholder="Gómez"
					label="Apellido"
					[isSubmitted]="isSubmitted"
					[formControl]="formUtilities.getControl(form, 'lastName')"
					name="lastName"
					[additionalValidators]="
						formUtilities.getValidators(form, 'lastName')
					" />

				<activar-input
					type="text"
					placeholder="12345678"
					label="DNI"
					[isSubmitted]="isSubmitted"
					[formControl]="formUtilities.getControl(form, 'identification')"
					name="identification"
					[additionalValidators]="
						formUtilities.getValidators(form, 'identification')
					"
					mask="dni" />

				<div>
					<label for="birthDate">Fecha de Nacimiento</label>
					<input
						formControlName="birthDate"
						id="birthDate"
						type="date"
						placeholder="Fecha de Nacimiento"
						class="input__base"
						[ngClass]="{
							error:
								formUtilities.getControl(form, 'birthDate')
									.invalid &&
								(formUtilities.getControl(form, 'birthDate')
									.touched ||
									isSubmitted),
						}" />
					@if (
						formUtilities.getControl(form, 'birthDate').errors?.[
							'ageError'
						]
					) {
						<div class="error">Debe ser mayor de 18 años.</div>
					}
					@if (
						formUtilities.getControl(form, 'birthDate').errors?.[
							'required'
						] && formUtilities.getControl(form, 'birthDate').touched
					) {
						<div class="error">Este campo es requerido.</div>
					}
				</div>
			}

			<!-- Common Fields -->
			<app-input-address
				formControlName="address"
				[formControl]="formUtilities.getControl(form, 'address')" 
				label="Dirección"
				[submitted]="isSubmitted"
				/>
			<input type="hidden" formControlName="zoneId"/>
			<activar-input
				type="text"
				placeholder="1234"
				label="Código Postal"
				maxlength="4"
				[isSubmitted]="isSubmitted"
				[formControl]="formUtilities.getControl(form, 'postalCode')"
				name="postalCode"
				(change)="checkPostalCode()"
				[additionalValidators]="
					formUtilities.getValidators(form, 'postalCode')
				" />


			@if (hasPostalCodeChanged()) {
				<div class="postal-code-warning bg-amber-50 border border-amber-200 rounded-lg p-3 -mt-2 mb-2">
					<div class="flex items-start">
						<activar-icon name="alert_warning" size="16px" class="text-amber-600 mt-0.5 pr-6 flex-shrink-0"></activar-icon>
						<p class="text-sm text-amber-800 leading-relaxed">
							Modificar el código postal puede afectar el precio diario de la cobertura de uso.
						</p>
					</div>
				</div>
			}

			@if (zones().length > 1) {
				<div>
					<label for="zone-select">Selecciona la zona</label>
					<select
						id="zone-select"
						class="input__base"
						[ngClass]="{ error: isSubmitted && !selectedZone() }"
						(change)="onZoneSelect($event)">
						<option value="">Selecciona una zona</option>
						@for (zone of zones(); track zone.id) {
							<option [value]="zone.id">{{ zone.name }} - {{ zone.province.name }}</option>
						}
					</select>
					@if (isSubmitted && !selectedZone()) {
						<div class="error">Debe seleccionar una zona.</div>
					}
				</div>
			}

			@if (checkingPostalCode()) {
				<div class="text-sm text-gray-600 mt-2">
					Verificando código postal...
				</div>
			}
		</div> 

		<div class="flex items-center justify-between gap-4 border-t pt-4 pb-6 flex-shrink-0 bg-white mt-4">
			<activar-button
				type="button"
				text="Cancelar"
				fill="out"
				expand="full"
				[disabled]="isLoading()"
				(click)="onCancel()" />
			<activar-button
				fill="solid"
				text="Confirmar"
				color="primary"
				expand="full"
				type="submit"
				[disabled]="!form.valid || !isModified()"
				[loading]="isLoading()" 
				loadingText="Actualizando..."/>
		</div>
	</form>
	}@else {
		<div class="flex flex-col w-full items-center justify-center mt-20 ">
			<activar-loading class="w-10"/>
			Modificando datos del tomador...
		</div>
		
	}
	
</div>


